<template>
    <div>
        <Navbar Title="Data Visualization"/>

        <div class="container">
        <div class="card mb-3">
            <h2 style="margin:2% 0 0 2%;font-family: 'Roboto';font-weight:300 ">Data Visualizer</h2>
            <p style="margin-left:2%;font-family: 'Roboto';font-weight:400">Edit data in the table to edit chart, you can download by clicking on top right of the chart.</p>
            <hr>

            <div class="container" style="padding:25px 25px"  :key="componentKey">
                <line-chart     v-if="chartDetails.type=='line'"        :curve="!chartDetails.stline"  :data="display" :xtitle="chartDetails.xLabel" :ytitle="chartDetails.yLabel" label="Value" :legend="chartDetails.legend" :download="true"> </line-chart>
                <pie-chart      v-else-if="chartDetails.type=='pie'"    :donut="chartDetails.donut" :data="display" :download="true"></pie-chart>
                <column-chart   v-else-if="chartDetails.type=='column'" :data="display" :xtitle="chartDetails.xLabel" :ytitle="chartDetails.yLabel" label="Value" :legend="chartDetails.legend" :download="true"></column-chart>
                <bar-chart      v-else-if="chartDetails.type=='bar'"    :data="display" :xtitle="chartDetails.xLabel" :ytitle="chartDetails.yLabel" label="Value" :legend="chartDetails.legend" :download="true"></bar-chart>
                <area-chart     v-else-if="chartDetails.type=='area'"   :curve="!chartDetails.stline"  :data="display" :xtitle="chartDetails.xLabel" :ytitle="chartDetails.yLabel" label="Value" :legend="chartDetails.legend" :download="true"></area-chart>
                <!-- <scatter-chart :data="display"></scatter-chart> -->
            </div>

            <hr>
          
            <div class="card-body">
                <label for="Type" class="col-sm-2 control-label">Select Chart Type:</label>
                <select id="Type" class="form-select" aria-label="Default select example" v-model="chartDetails.type">
                    <option value="line">Line</option>
                    <option value="pie">Pie</option>
                    <option value="column">Column</option>
                    <option value="bar">Bar</option>
                    <option value="area">Area</option>
                </select>

                <br>

                <div class="row">
                    <div class="switch col" v-if="chartDetails.type!='pie'" ><label>Show or hide legend<input type="checkbox" v-model="chartDetails.legend"><span class="lever"></span></label></div>
                    <div class="switch col" v-if="chartDetails.type=='pie'"><label>Donut chart<input type="checkbox" v-model="chartDetails.donut"><span class="lever"></span></label></div>
                    <div class="switch col" v-if="chartDetails.type=='line'||chartDetails.type=='area'"><label>Straight lines between points<input type="checkbox" v-model="chartDetails.stline"><span class="lever"></span></label></div>
                </div>
                

                <br>

                <table class="table caption-top table-hover table-bordered">
                    <caption>Data Table :</caption>
                    <thead class="table-secondary">
                        <tr class="center">
                        <th scope="col">#</th>
                        <th scope="col">
                            <input type="text" placeholder="X-Axis Title" v-model="chartDetails.xLabel"/>
                        </th>
                        <th scope="col">
                            <input type="text" placeholder="Y-Axis Title" v-model="chartDetails.yLabel"/>
                        </th>
                        <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr v-for="(data,index) in chartData" :key="index">
                            <th scope="row">{{index+1}}</th>
                            <td><input type="text" @input="updateData(index)" v-model="(chartData[index]).x"/></td>
                            <td><input type="text" @input="updateData(index)" v-model="(chartData[index]).y"/></td>
                            <td class="center ">
                                    <i class="col material-icons delete" style="cursor:pointer" @click="deleteData(index)">delete</i>
                            </td>
                        </tr>

                        <tr>
                            <th scope="row"></th>
                            <td><input type="text" placeholder="Add data"  v-model="another.x"/></td>
                            <td><input type="text" placeholder="Add data" v-model="another.y" @keydown.tab.prevent="addData"/></td>
                            <td class="center">
                                <i class="col material-icons add"    @click="addData" style="cursor:pointer">add_circle</i>
                                <p v-if="feedback" class="red-text">{{feedback}}</p>
                            </td>
                        </tr>

                    </tbody>
                </table>
                <!-- <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p> -->
                <!-- <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p> -->

            </div>
            
        </div>
        </div>

    </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Vue from 'vue'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

Vue.use(Chartkick.use(Chart))

export default {
    name: 'Data-viz',
    components: {
        Navbar,
    },
    data() {
        return{
            chartDetails:{"type":"line","xLabel":"","yLabel":"Price","legend":true,"stline":false,"donut":false},
            chartData :[{ "x": "Apple", "y": 10 }, { "x": "Peach", "y": 25 }, { "x": "Oranges", "y": 74 }, { "x": "Banana", "y": 55 } ],
            display:[ [ "Apple", "10" ], [ "Peach", "25" ], [ "Oranges", "74" ], [ "Banana", "55" ]],
            another:[],
            feedback:null,
            componentKey:0,
        }
    },
    methods:{
        alert(){
            alert('helllo')
        },
        addData()
        {
            if(this.another.x && this.another.y)
            {
                var data = {"x":this.another.x,"y":parseFloat(this.another.y)}
                this.chartData.push(data)
                this.display.push([this.another.x,this.another.y])
                this.another= [...[]]
                this.feedback=null
            }else{
                this.feedback="Error!!"
            }
        },
        updateData(index)
        {
            this.display[index][0]=this.chartData[index].x
            this.display[index][1]=this.chartData[index].y
            this.componentKey+=1
        },
        deleteData(index)
        {
            this.chartData.splice(index,1)
        }
    }
}
</script>

<style scoped>


</style>